export const STATIC_MAP_RESIZE_REFETCH_TIMEOUT_IN_MS = 250;

export const MAX_LAT = 90;
export const MAX_LNG = 180;

export const MIN_ZOOM_LEVEL = 0;
export const MAX_ZOOM_LEVEL = 11;
export const INIT_ZOOM_LEVEL = 6;
export const MAX_DISTANCE_FOR_STATIC_MAP_MAX_ZOOM = 5;

export const MAP_HEIGHT = 240;
export const DEALERSHIP_LOCATION_ICON_URL = 'http://motorway-static.imgix.net/static/dealership-icon.png?w=40&h=40';
export const VEHICLE_LOCATION_ICON_URL = 'http://motorway-static.imgix.net/static/vehicle-location-icon.png?w=40&h=40';
